// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"8f92a768","666":"1d71379a","787":"3fd98a79","839":"f9662672"}[chunkId] + ".chunk.js";
};